import { render, staticRenderFns } from "./nvLayoutCell.vue?vue&type=template&id=ca2b41de&scoped=true&"
import script from "./nvLayoutCell.vue?vue&type=script&lang=ts&"
export * from "./nvLayoutCell.vue?vue&type=script&lang=ts&"
import style0 from "./nvLayoutCell.vue?vue&type=style&index=0&id=ca2b41de&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2b41de",
  null
  
)

export default component.exports